const initState = {
  selectedVideo: {},
  videosLibraryData: [],
  videosLibraryDataCount: 0,
  selectedInstructionVideos: [],
  vedioPagination: {
    page: 1,
    limit: 12,
    total: 0,
    totalPages: 0,
  },
};
const videosLibraryReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_VIDEOS_LIBRARY_DATA":
      return {
        ...state,
        videosLibraryData: action.payload.data,
      };
    case "SET_VIDEOS_LIBRARY_DATA_COUNT":
      return {
        ...state,
        videosLibraryDataCount: action.payload.data,
      };
    case "SET_SELECTED_VIDEO":
      return {
        ...state,
        selectedVideo: action.payload.data,
      };
    case "SET_SELECTED_INSTRUCTION_VIDEOS":
      return {
        ...state,
        selectedInstructionVideos: action.payload.data,
      };
    case "CLEAR_SELECTED_INSTRUCTION_VIDEOS":
      return {
        ...state,
        selectedInstructionVideos: [],
      };
    case "SET_VIDEOS_PAGINATION":
      return {
        ...state,
        vedioPagination: action.payload.data,
      };

    default:
      return { ...state };
  }
};

export default videosLibraryReducer;
